import { render } from "./RequiresApproval.vue.js?vue&type=template&id=af74a9da!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./RequiresApproval.vue?vue&type=template&id=af74a9da"
import script from "./RequiresApproval.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./RequiresApproval.vue?vue&type=script&lang=js"
export * from "./RequiresApproval.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./RequiresApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/stories/RequiresApproval.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af74a9da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af74a9da', __exports__)) {
    api.reload('af74a9da', __exports__)
  }
  
  module.hot.accept("./RequiresApproval.vue.js?vue&type=template&id=af74a9da!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./RequiresApproval.vue?vue&type=template&id=af74a9da", () => {
    api.rerender('af74a9da', render)
  })

}


export default __exports__